import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Injectable } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BlAuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,

    private router: Router
  ) {}

  public canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isLoggedIn()) {
      this.router.navigate(['/al/board']);
      return false;
    }
    return true;
  }
}
